import { RouteObject } from 'react-router-dom';
import { LanguageValidator } from '../components/LanguageValidator';

/**
 * Creates language-aware routes following the pattern: {basePath}/{language}/{remainingParts}
 * Supports both /en and /ar prefixes while maintaining backward compatibility for English
 *
 * Strategy: Wrap routes with an optional language parameter (:lang?) that validates
 * and handles language switching without duplicating the entire route tree
 */
export const createLanguageRoutes = (baseRoutes: RouteObject[]): RouteObject[] => {
  // Helper function to recursively convert absolute paths to relative paths
  const makePathsRelative = (routes: RouteObject[]): RouteObject[] => {
    return routes.map((route: any) => {
      const newRoute: any = { ...route };

      // Convert absolute paths to relative (remove leading slash)
      if (newRoute.path && typeof newRoute.path === 'string' && newRoute.path.startsWith('/')) {
        newRoute.path = newRoute.path.substring(1); // Remove leading slash

        // Handle root path specially - empty string for index route behavior
        if (newRoute.path === '') {
          // Keep it as empty string for index-like behavior
        }
      }

      // Recursively handle children
      if (newRoute.children && Array.isArray(newRoute.children)) {
        newRoute.children = makePathsRelative(newRoute.children);
      }

      return newRoute;
    });
  };

  // Convert all absolute paths to relative paths
  const relativeRoutes = makePathsRelative(baseRoutes);

  // Create a wrapper route with optional language parameter
  const languageRoute: RouteObject = {
    path: '/:lang?',
    element: <LanguageValidator />,
    children: relativeRoutes,
  };

  return [languageRoute];
};
